import {
    centsToLocalizedString,
    moneyToLocalizedString,
    DisplayLocale,
    toDecimalFromMoney,
    toMoneyFromCents,
} from "../../../lib/Money.ts";
import { getCurrencySymbol } from "../../../lib/utils.ts";
import { DEFAULT_CURRENCY } from "../types";

export function centsToDecimal(amountInCents: number): number {
    return toDecimalFromMoney(toMoneyFromCents(amountInCents, DEFAULT_CURRENCY));
}

export function formatQuinnAmount(amountInCents: number, currency: string = DEFAULT_CURRENCY): string {
    return `${centsToLocalizedString(amountInCents, DisplayLocale.NL_NL)} ${currency}`;
}

export function formatQuinnEuroFromCents(amountInCents: number): string {
    const money = toMoneyFromCents(amountInCents, DEFAULT_CURRENCY);
    const amount = moneyToLocalizedString(money, DisplayLocale.NL_NL, 2, true);
    const sign = amountInCents < 0 ? "-" : "";
    return `${sign}${getCurrencySymbol(DEFAULT_CURRENCY)} ${amount}`;
}

export function formatQuinnDeltaFromCents(amountInCents: number): string {
    const money = toMoneyFromCents(amountInCents, DEFAULT_CURRENCY);
    const amount = moneyToLocalizedString(money, DisplayLocale.NL_NL, 2, true);
    const sign = amountInCents > 0 ? "+" : amountInCents < 0 ? "-" : "";
    return `${sign}${getCurrencySymbol(DEFAULT_CURRENCY)} ${amount}`;
}
